export default "__VITE_ASSET__327ef5aa__"